module.exports = __webpack_public_path__ + "static/media/racket.d61aee56.png";